import React from 'react';
import { BikeIcon, Building2Icon as HousePlusIcon, CarFrontIcon, HomeIcon, PlusIcon } from 'lucide-react';
import type { CardAsset } from '../../data/carte';
interface AssetsSectionProps {
  id: string;
  title: string;
  items: CardAsset[];
  addLabel?: string;
}
const icons = {
  home: HomeIcon,
  cottage: HousePlusIcon,
  car: CarFrontIcon,
  bike: BikeIcon
};

/** Section de Ma carte au même gabarit que « Mes animaux » : pastilles rondes + « Ajouter ». */
export function AssetsSection({
  id,
  title,
  items,
  addLabel = 'Ajouter'
}: AssetsSectionProps) {
  const titleId = `${id}-carte-titre`;
  return <section id={id} aria-labelledby={titleId} className="mt-8 scroll-mt-28 rounded-3xl bg-slate-50 p-7 sm:p-8" data-id="element-594" data-mp="2tk4dq9bny8p9">
      <h2 id={titleId} className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-595" data-mp="2pjkff2fcsz1j">
        {title}
      </h2>

      <ul className="mt-6 grid grid-cols-4 gap-x-4 gap-y-6" data-id="element-596" data-mp="z63e3m8ahho4">
        {items.map(item => {
        const Icon = icons[item.icon];
        return <li key={item.id} data-id="element-597" data-mp="2lnminfz29jnv">
              <button type="button" className="group flex w-full flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-598" data-mp="2lopabq47jq4u">
                <span className="relative inline-block" data-id="element-599" data-mp="2vj7f6yld1rq8">
                  <span className="grid h-[76px] w-[76px] place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo ring-4 ring-white transition-transform duration-150 ease-ville group-hover:-translate-y-0.5" data-id="element-600" data-mp="30d28mtqrpl2i">
                    <Icon className="h-8 w-8" strokeWidth={1.75} aria-hidden="true" data-id="element-601" data-mp="39b45cx3gxrjz" />
                  </span>
                  <span className={`absolute bottom-0.5 right-0.5 h-[18px] w-[18px] rounded-full ring-[3px] ring-white ${item.active ? 'bg-ville-indigo' : 'bg-slate-400'}`} aria-hidden="true" data-id="element-602" data-mp="3ecl1kfb0cpu8" />
                </span>
                <span className="mt-2 text-[15px] font-bold leading-tight text-ville-navy" data-id="element-603" data-mp="1oyompufkrfp4">{item.name}</span>
                <span className="text-[13px] text-slate-500" data-id="element-604" data-mp="1cukfia8wh76a">{item.detail}</span>
              </button>
            </li>;
      })}

        <li data-id="element-605" data-mp="1qvd7oobqbq68">
          <button type="button" className="group flex w-full flex-col items-center text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-606" data-mp="1qvwuaicbr2ql">
            <span className="grid h-[76px] w-[76px] place-items-center rounded-full bg-white text-slate-400 ring-1 ring-slate-200 transition-colors duration-150 ease-ville group-hover:text-ville-indigo group-hover:ring-ville-indigo" data-id="element-607" data-mp="1ztgt7kmpsmy1">
              <PlusIcon className="h-7 w-7" aria-hidden="true" data-id="element-608" data-mp="24lqgeswg38wm" />
            </span>
            <span className="mt-2 text-[15px] font-bold leading-tight text-ville-indigo" data-id="element-609" data-mp="24ntf01bnyacy">{addLabel}</span>
          </button>
        </li>
      </ul>
    </section>;
}